/* eslint-disable */
import React, { useEffect, useContext, useMemo, useState } from "react";
import { observer } from "mobx-react-lite";
import ReactJkMusicPlayer from "react-jinke-music-player";
import "../AudioPlayer/core.css";
import { StoreContext } from "../../../contexts";
import { useAudioPlayerActivity } from "../../../activity/hooks";
import { findTrackBySrc } from "../../../activity/content";
import classes from "./AudioPlayer.module.scss";
import { isMobile } from "react-device-detect";
import { Authorization } from "../../organisms/RestrictionModal/RestrictionModal";
import classNames from "classnames";

const defaultOptions = {
    theme: "light",
    remember: false,
    remove: false,
    autoplay: true,
    loadAudioErrorPlayNext: false,
    autoPlayInitLoadPlayList: false,
    defaultPosition: {
        right: 30,
        bottom: 5,
    },
    showDownload: false,
    showThemeSwitch: false,
    showLyric: false,
    lyric: false,
    mode: "full",
    clearPriorAudioLists: true,
    toggleMode: false,
};

const SingleAudioPlayer = observer(({ playlist, disabledControl = false, playIndex = 0, onAudioInstance, autoPlay = true }) => {
    const { authorization, partnership, common } = useContext(StoreContext);
    const [audioInstance, setAudioInstance] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const [playerOptions, setPlayerOptions] = useState({});

    // Reports the member's listening (src/activity): each playlist item carries the library
    // content it is as `activity`, found by the <audio> element's src.
    const findTrack = useMemo(() => findTrackBySrc(playlist, (track) => track.activity), [playlist]);
    useAudioPlayerActivity(audioInstance, findTrack);

    const popup = {
        onOpen: () => setIsOpen(true),
        onClose: () => setIsOpen(false),
        isOpen,
    };

    useEffect(() => {
        delete window.initialLoad;
        delete window.handleAudioCalled;
    }, []);

    useEffect(() => {
        partnership.getPartnership();
    }, [authorization.isAuthenticated]);

    useEffect(() => {
        if (!playlist.length) return;

        const options = {
            ...defaultOptions,
            audioLists: playlist,
            defaultPlayIndex: playIndex,
            renderAudioTitle: function (audioInfo) {
                return (
                    <div className={classes.audioTitleWrapper}>
                        <span className={classes.audioTitle}>{audioInfo.name}</span>
                        {audioInfo.singer && (
                            <span className={classes.audioArtist}> — {audioInfo.singer}</span>
                        )}
                    </div>
                );
            },
        };

        setPlayerOptions(options);
    }, [playlist]);

    useEffect(() => {
        const audioPlayer = document.querySelector(".music-player-audio");

        const handlePlay = () => {
            const isAuthorized =
                authorization.isUserMember && authorization.canAccessAudioPlayer;

            if (!isAuthorized) {
                popup.onOpen();
                setTimeout(() => {
                    audioPlayer?.pause();
                }, 100);
            } else {
                try {
                    if (isMobile) {
                        document.querySelector(".audio-lists-btn")?.click();
                    }

                    const audioListBtn = document.querySelector(".audio-lists-btn");
                    if (audioListBtn) {
                        audioListBtn.style.display = "flex";
                    }
                } catch (e) {
                    console.warn("Mobile audio list UI error:", e);
                }
            }
        };

        if (audioPlayer) {
            audioPlayer.onplay = handlePlay;
        }

        if (audioPlayer) {
            audioPlayer.onpause = () => {
                common.set('isAudioPlayerOpen', false);
            };
            audioPlayer.onplay = () => {
                common.set('isAudioPlayerOpen', true);
            };
        }

        return () => {
            if (audioPlayer) {
                audioPlayer.onplay = null;
            }
        };
    }, [playlist, authorization]);

    return (
        <>
            <Authorization
                popup={popup}
                authorization={authorization}
                partnership={partnership}
            />

            <div className="music-player-audio-preview">
                {playlist.length > 0 && playerOptions.audioLists && (
                    <ReactJkMusicPlayer
                        {...playerOptions}
                        autoPlay={autoPlay}
                        getAudioInstance={(instance) => {
                        setAudioInstance(instance);
                        if (onAudioInstance) onAudioInstance(instance);
                    }}
                        className={`music-player-audio-preview ${disabledControl ? "music-player-audio-preview-disable-control" : ""}`}
                        sortableOptions={{
                            swap: false,
                            sort: false,
                            animation: 100,
                            disabled: true,
                            swapClass: "audio-lists-panel-sortable-highlight-bg",
                        }}
                    />
                )}
            </div>
        </>
    );
});

export default SingleAudioPlayer;
